import {Box} from '@mui/material';
import type {ReactNode} from 'react';
import React from 'react';

export interface ModalFooterProps {
    /** linksbündiger Slot, z. B. ein Link-Button ("Vertrag anzeigen") */
    left?: ReactNode;
    /** rechtsbündige Aktionen (Buttons) */
    children?: ReactNode;
}

export function ModalFooter({left, children}: ModalFooterProps) {
    return (
        <Box
            sx={{
                mt: 'auto',
                px: 2.75,
                py: 1.5,
                borderTop: 1,
                borderColor: 'divider',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 1.5,
            }}
        >
            <Box sx={{display: 'flex', alignItems: 'center', gap: 1, minWidth: 0}}>{left}</Box>
            <Box sx={{display: 'flex', gap: 1.25}}>{children}</Box>
        </Box>
    );
}